/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import { motion } from 'framer-motion'
import React,{useState,useEffect,useCallback,useContext} from 'react'
import ReactModal from 'react-modal'
import { connect } from 'react-redux'
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'
import HeaderContext from '../../../Components/Context/HeaderContext'
import { DistributorActions } from '../../../redux/actions'
import { WishlistedProduct } from '../../../redux/helper/AddWishlist'
import { generateDateWithTime } from '../../../redux/helper/DateConverter'
import { distributorService } from '../../../service/distributor.service'
import SubscribeModal from '../Modals/subscribeModal'
import SubscribeSuccess from '../Modals/subscribeSuccess'
import AllOfferProgress from './AllOfferProgress'
import CriteriaDetail from './CriteriaDetail'
import CriteriaHeaders from './CriteriaHeaders'
import NotmatchingPopup from './NotmatchingPopup'
import OfferDetailsShimmer from './OfferDetailSkeleton'
import ProductSection from './Products';

import './style.css'
const  BulkOfferDetails =({ViewBulkOffer,GetBulkOfferDetails,ProductList,Products,offerData,GetOfferData,cartList}) =>{
    const navigate = useNavigate();
    const {subscription}=useParams()
    const [searchParam, setSearchParam] = useSearchParams()
    const id = searchParam.get('code')
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
    } = useContext(HeaderContext);
    const [prod, setprod] = useState([]);
    const [result, setresult] = useState([])
    const [showProducts, setshowProducts] = useState(false);
    const [selectedCriteria, setselectedCriteria] = useState(0);
    const [CriteriaObj, setCriteriaObj] = useState({});
    const [responsivePopup, setresponsivePopup] = useState(false);
    const [cartProducts, setcartProducts] = useState([]);
    const [loading, setloading] = useState(true);
    const [productsloader, setproductsloader] = useState(true);
    const [specialCartList, setspecialCartList] = useState({})
    const [cartCountObj, setcartCountObj] = useState({});
    const [criteriaObject, setcriteriaObject] = useState([]);
    const [overAllCriteria, setOverAllCriteria] = useState([]);
    const [IsSameDeal, setIsSameDeal] = useState('');
    const [showNotMaching, setshowNotMaching] = useState('');
    const [notmatchingLoader, setnotmatchingLoader] = useState(false);
    const [wishlistProduct, setwishlistProduct] = useState([]);
    const [searchValue, setsearchValue] = useState('');
    const [categories, setCategories] = useState({});
    const [subscribeModal, setSubscribeModal] = useState(false);
    const [subscriptionDetails, setSubscriptionDetails] = useState([]);
    const [subscriptionSuccessModal, setSubscriptionSuccessModal] = useState(false);
    const [Subscription, setSubscription] = useState({})
    const [threedotLoader, setThreedotLoader] = useState(false);
    const [priceRange, setpriceRange] = useState({
        minValue:0,
        maxValue:0
    })
    const [Size, setSize] = useState({
        LENGTH:"",
        DIAMETER:""
    })

    const [filterParam, setFilterParam] = useState({
        LENGTH:[],
        DIAMETER:[]
    })

    
    const initialState={
        "deal": id,
        "criteria": selectedCriteria,
        "page": 1,
        "limit": 10,
        "search": searchValue,
        "filter":{
            "DIAMETER":undefined,
            "SIZE":undefined,
            "category":undefined
        }
    }
    // const initialState={
    //     "page":1,
    //     "limit":10,
    //     "sort": 'EXPECTED_DELIVERY_DATE asc',}
    const [payload, setpayload] = useState(initialState);
    const handleObjCreation=(items)=>{
        let status = []
        const temp={...CriteriaObj}
        const storeproducts=offerData?.products
        items?.product_criterion.map((val,i)=>{
            if(!temp[val.id]){
                temp[val.id]={
                    payload:initialState,
                    orderValue:0,
                    products:storeproducts||[],
                    number_of_pages:0,
                    cartCount:{},
                    ProductExist:status.length>0

                }
            }
        })
        GetOfferData(temp)
        setCriteriaObj(temp);
    }
   
    const handleFetch = useCallback(
        async(key) => {
            GetBulkOfferDetails(id).then(async(res)=>{
                if(!res.error && res.data.success_status){
                    setprod(res.data?.data?.product_criterion);
                    setloading(false);
                    handleObjCreation(res.data.data)
                    const listwish= await WishlistedProduct();
                    setwishlistProduct(listwish)
                    SpecialList()
                }
            })
        },
        [],
    )

    const handleFetchSubscription = useCallback(
        async() => {
            distributorService.SubscriptionGet(subscription).then(async(res)=>{
                if(!res.error && res.data.success_status){
                    setSubscription(res.data.data)
                }
            })
        },
        [],
    )
    const SpecialList = 
        async(objectCopy,prodcts) => {
            let product=prodcts||prod
            if (subscription !== undefined){
                const special_list = await distributorService.CartDealList(subscription);
                if(!special_list.error){
                    const checkKey=Object.values(special_list.data.data)[0]
                    if(Object.keys(special_list.data.data).length > 0 && checkKey?.deal !== id){
                        setIsSameDeal([special_list.data.data][0].deal)
                    }else{
                        setspecialCartList(special_list.data.data);
                        setcriteriaObject(special_list.data.criteria);

                    }
                    setOverAllCriteria(special_list.data.current_critria)
                    let obj =objectCopy || {...CriteriaObj}
                    const list=special_list.data.data;
                    let count =obj[prod[selectedCriteria]?.id]?.cartCount||{...cartCountObj};
                    if (Object.keys(list).length>0){
                        Object.keys(list).map((item)=>{
                            if(count[list[item].CONCATENATED_SEGMENTS]){
                                count[list[item].CONCATENATED_SEGMENTS]=Number(list[item].quantity)||count[list[item].CONCATENATED_SEGMENTS] ;
                            }else{
                                count[list[item].CONCATENATED_SEGMENTS]=Number(list[item].quantity)||0;
                            }
                        })}
                    else{
                        count = {}
                    }
                    setcartCountObj(count)
                    obj[product[selectedCriteria]?.id].cartCount=count
                    setCriteriaObj(obj);
                }
            }
        }
            
    const handleSubscription= async()=>{
        setThreedotLoader(true);
        const subscription = await distributorService.CreateSubscription(id);
        if(!subscription.error && subscription.data.success_status){
            setSubscriptionDetails(subscription.data)
            handleSuccessMessage(subscription.data.message)
            setThreedotLoader(false)
            setSubscribeModal(false)
        }
    }
    const handleCartCount=useCallback(
        (items,criteria,prod,id,products) => {
            const countcopy={...cartCountObj}
            const data=offerData
            let obj ={...offerData?.items ||criteria}
            let count ={...cartCountObj};

            items && items.map((val)=>{
                if(count[val.CONCATENATED_SEGMENTS]){
                    count[val.CONCATENATED_SEGMENTS]=Number(count[val.CONCATENATED_SEGMENTS]);
                }else{
                    count[val.CONCATENATED_SEGMENTS]=0;
                }
                if(countcopy[val.CONCATENATED_SEGMENTS]){
                    countcopy[val.CONCATENATED_SEGMENTS]=Number(countcopy[val.CONCATENATED_SEGMENTS]);
                }else{
                    countcopy[val.CONCATENATED_SEGMENTS]=0;
                }
            })
            setcartCountObj(countcopy)
            return obj; 
        },
        [],
    )
    const handleCat=(item)=>{
        let arr=[];
        item.map((val)=>{
            arr.push(val.CATEGORY_CONCAT_SEGS)
        })
        return arr;
    }
    const GetProductList = useCallback(
        async(objCopy,key,payloadFromFilter) => {
            let payloadValue=payloadFromFilter?payloadFromFilter:payload
            const obj={...CriteriaObj}
            if(searchValue !=='' ||searchValue !==undefined){
                payloadValue.search=searchValue===''?undefined:searchValue
            }
            payloadValue.criteria=selectedCriteria
            const list = await distributorService.getBulkDealsProducts(payloadValue);
            if(!list.error && list.data.data.success_status){
                if(list.data?.category){
                    setCategories(list.data.category)
                    setFilterParam({'DIAMETER': list.data.filter_size, 'LENGTH': list.data.filter_length})
                }
                let myprod=payloadFromFilter?[]:obj[prod[selectedCriteria]?.id]?.products||[];
                if(payloadValue?.search?.length===''||payloadValue?.search?.length===undefined){
                    list?.data?.data?.data.forEach(book => {
                        const idx = myprod.map((val)=>val.CONCATENATED_SEGMENTS).indexOf(book.CONCATENATED_SEGMENTS)
                        if(idx=== -1){
                            myprod.push(book);
                        }
                    });
                }else{
                    myprod=list.data.data.data
                }
                obj[prod[selectedCriteria].id].products=myprod
                obj[prod[selectedCriteria].id].number_of_pages=list?.data?.data?.number_of_pages
                obj[prod[selectedCriteria].id].total_result=list?.data?.data?.total_result
                if(list.data.data.data.length>0){
                    handleCartCount(list.data.data.data,CriteriaObj,prod,selectedCriteria);
                }
                obj.products=offerData.products||[]
                setCriteriaObj(obj)
                setresponsivePopup(false);
                setproductsloader(false)
            }
            
            
        },
        [showProducts,searchValue,payload],
    )
    
    useEffect(() => {
        setproductsloader(true);
        GetProductList()
    }, [GetProductList])
    
    useEffect(() => {
        handleFetch()
    }, [handleFetch])

    useEffect(() => {
        if (subscription !== undefined){
            handleFetchSubscription()
        }
    }, [])

    const handleSuccessMessage = (name)=>{
        setSubscriptionSuccessModal(true)
        // SetSuccessMessage(name);
        setTimeout(() => {
            SetSuccessMessage('');
            setshowNotMaching('');
            setcolorValue(false);
            setSubscriptionSuccessModal(false)
            navigate('/bulk-offer')
        },3000)
    }
    const handleClearCart =async()=>{
        const cart = await distributorService.clearCart('key');
        if(!cart.error && cart.data.success_status){
            setIsSameDeal('')
            handleSuccessMessage(cart.data.message)
            setshowProducts(false);
            handleFetch()
        }

    }   
    
    return (
        <>
            <>{loading && <OfferDetailsShimmer />}</>
            { !loading && ViewBulkOffer && (
                <motion.div
                    animate={{ opacity: 1, x: 0 }}
                    initial={{ opacity: 0, x: -10 }}
                    exit={{ opacity: 0, x: -10 }}
                    transition={{ duration: 0.15 }}  className="md:px-[46px] px-4 pt-2 mb-7">
                    <p onClick={()=> navigate(-1)} className="text-[#090406] font-normal cursor-pointer text-xs2">{`Offers > ${ViewBulkOffer?.items?.offer_code}`}</p>
                    <div className="flex lg:flex-nowrap flex-wrap relative">
                        <div className="w-full">
                            {subscription !== undefined ? 
                                <div className="flex items-start w-full sm:flex-row flex-col pt-[15px]">
                                    <img src="/images/related-offer.svg" alt="icon"/>
                                    <div className="sm:pl-[26px] pl-0 w-full">
                                        <p className="font-semibold sm:text-2xl text-xl text-[#090406] break-words">{subscription} <span className="pl-[6px] text-xs font-normal text-[#44445E]"> Subscribed On: {generateDateWithTime(Subscription.created_at)} </span></p>
                                        <p className="sm:text-xl text-base font-semibold text-[#555259] sm:pt-2 pt-0.5">{ViewBulkOffer?.items?.offer_code}</p>
                                        <p className="text-[#44445E] font-normal sm:text-xs9 text-sm sm:my-[6px] my-1">{ViewBulkOffer?.items?.start_date.split('-').reverse().join('/')} - {ViewBulkOffer?.items?.end_date.split('-').reverse().join('/')}<span className="px-2">|</span><span className="font-normal">{ViewBulkOffer?.items?.offer_value}</span></p>
                                        <p className="text-[#44445E] font-normal sm:text-xs7 text-sm sm:pt-4 pt-1.5">{ViewBulkOffer?.items?.description}</p>
                                    </div>
                                </div> : 
                                <div className="flex items-center mt-2.5 w-full">
                                    <img src="/images/related-offer.svg" alt="icon" className="w-[76px] h-[76px] flex items-center sm:block hidden" />
                                    <div className="sm:pl-[26px] pl-2 w-full">
                                        <div className="flex justify-between sm:flex-row flex-col">
                                            <p className="font-bold text-[#000000] sm:text-xs15 text-lg">{ViewBulkOffer?.items?.offer_code}</p>
                                            <ul className="flex items-center">
                                                <li className="ml-2">
                                                    <button type="button" className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-2 py-1 w-fit">{ViewBulkOffer?.items?.industrial_pocket}</button>
                                                </li>
                                            </ul>
                                        </div>
                                        <p className="text-[#44445E] font-normal sm:text-xs9 text-base pt-3">Validity: <span className="text-[#000000] font-semibold sm:text-xs9 text-base"> {ViewBulkOffer?.items?.start_date.split('-').reverse().join('/')} - {ViewBulkOffer?.items?.end_date.split('-').reverse().join('/')}</span><span className="px-2">|</span>{ViewBulkOffer?.items?.offer_value}</p>
                                        <p className="text-[#44445E] font-normal sm:text-xs7 text-sm pt-4">{ViewBulkOffer?.items?.description} </p>
                                    </div>
                                </div>}
                            <div className="flex items-start pt-4 sm:pl-[102px] pl-0 note1">
                                <img src="/images/note.svg" alt="icon" className="pt-1" />
                                <p className="font-semibold sm:text-sm text-sm text-[#555259] pl-1">Note: </p>
                                <p className="text-[#ED1C24]">* <span className="font-semibold text-[#808285] sm:text-base text-sm">*Criteria(s) is/are mandatory to be complied in term of quantity or value, whichever is applicable.</span></p>
                            </div>
                        </div>
                        {subscription !== undefined ? <AllOfferProgress
                            CriteriaObj={CriteriaObj}
                            prodItem={criteriaObject}
                            GetCartItems={handleFetch}
                            Subscription={Subscription}
                            setCriteriaObj={setCriteriaObj}
                            selectedCriteria={selectedCriteria}
                            GetOfferData={GetOfferData}
                            ViewBulkOffer={ViewBulkOffer}
                            offerData={offerData}
                            initialState={initialState}
                            GetProductList={GetProductList}
                            responsivePopup={responsivePopup}
                            setresponsivePopup={setresponsivePopup}
                            cartList={cartList}
                            specialCartList={specialCartList}
                            ViewData={offerData}
                            setcartProducts={setcartProducts}
                            handleFetch={handleFetch}
                            cartProducts={cartProducts}
                            overAllCriteria={overAllCriteria} /> : 
                            (
                                <div className="lg:min-w-[35%] min-w-full h-auto lg:ml-[18px] ml-0 self-end">
                                    <button 
                                        type="button" 
                                        className="w-[40%] bg-[#555259] rounded-[8px] text-[#FFFFFF] text-sm font-semibold py-3 lg:mt-0 mt-3" 
                                        data-bs-toggle="modal" 
                                        data-bs-target="#subscribeToBulkOffer"
                                        onClick={() => setSubscribeModal(true)}
                                    >
                                        Subscribe to Bulk Offer
                                    </button>
                                </div>
                            )}
                    </div>
                    <CriteriaHeaders 
                        ViewBulkOffer={ViewBulkOffer}
                        selectedCriteria={selectedCriteria} 
                        setselectedCriteria={setselectedCriteria}
                        setsearchValue={setsearchValue}
                        setshowProducts={setshowProducts}/>
                    <div className="tab-content w-full" id="pills-tabContentVertical">
                        <div className="tab-pane fade show active w-full" id="home3" role="tabpanel" aria-labelledby="pill3">
                            <div className="bg-[#F5F5FA] rounded-lg border-2 border-[#E9EDF4] mt-[30px]">
                                <CriteriaDetail ViewBulkOffer={ViewBulkOffer} selectedCriteria={selectedCriteria}/>
                            </div>
                            {showProducts && <div className="flex justify-end items-center mt-4 cursor-pointer hide-products" onClick={()=>setshowProducts(false)}>
                                <p className="text-[#44445E] font-normal text-xs2">Hide Products</p>
                                <img src="/images/chevron-down1.svg" alt="icon" className="ml-1" />
                            </div>}
                            <div className={`products  ${!showProducts?'hidden':''}`} >
                                <div className="flex w-full mt-6 lg:flex-nowrap flex-wrap pb-6">
                                    {showProducts &&
                                        <>{ViewBulkOffer?.items?.product_criterion.map((item,i)=>(
                                            selectedCriteria===i &&(
                                                <div className="lg:min-w-[75%] w-full mr-0" key={i}>
                                                    <ProductSection 
                                                        setsearchValue={setsearchValue}
                                                        CriteriaObj={CriteriaObj}
                                                        prodItem={prod}
                                                        GetCartItems={GetProductList}
                                                        setCriteriaObj={setCriteriaObj}
                                                        selectedCriteria={selectedCriteria}
                                                        setselectedCriteria={setselectedCriteria}
                                                        GetOfferData={GetOfferData}
                                                        ViewBulkOffer={ViewBulkOffer}
                                                        offerData={offerData}
                                                        initialState={initialState}
                                                        GetProductList={GetProductList}
                                                        responsivePopup={responsivePopup}
                                                        setresponsivePopup={setresponsivePopup}
                                                        prod={prod}
                                                        setcartProducts={setcartProducts}
                                                        cartProducts={cartProducts}
                                                        offerId={id}
                                                        productsloader={productsloader}
                                                        SpecialList={SpecialList}
                                                        cartCountObj={cartCountObj}
                                                        specialCartList={specialCartList}
                                                        setshowProducts={setshowProducts}
                                                        criteriaObject={criteriaObject}
                                                        handleCat={handleCat}
                                                        showNotMaching={showNotMaching}
                                                        setshowNotMaching={setshowNotMaching}
                                                        wishlistProduct={wishlistProduct}
                                                        setloading={setloading}
                                                        result={result}
                                                        setresult={setresult}
                                                        categories={categories}
                                                        setcartCountObj={setcartCountObj}
                                                        Size={Size}
                                                        setSize={setSize}
                                                        priceRange={priceRange}
                                                        setpriceRange={setpriceRange}
                                                        setproductsloader={setproductsloader}
                                                        IsSameDeal={IsSameDeal}
                                                        filterParam={filterParam}
                                                        subscription={subscription}
                                                        overAllCriteria={overAllCriteria}/>
                                                </div>
                                            )
                                        ))}</>
                                    }</div>
                            </div>
                            {!showProducts &&<div className="flex justify-center mt-10" onClick={()=>setshowProducts(true)}>
                                <button type="button" className="w-[210px] h-10 bg-[#555259] rounded-lg text-sm text-[#FFFFFF] font-semibold view-products">
                                    View Products
                                </button>
                            </div>}
                        </div>
                    </div>
                    <ReactModal style={{overFlow:'auto'}}  isOpen={showNotMaching!==''}>
                        <NotmatchingPopup
                            setremovePopup={setshowNotMaching}
                            handleClearCart={handleClearCart}
                            loading={notmatchingLoader}
                            setremoveLoader={setnotmatchingLoader}
                        />
                    </ReactModal>
                    {subscribeModal && <SubscribeModal
                        subscribeModal={subscribeModal}
                        setSubscribeModal={setSubscribeModal}
                        handleSubscription={handleSubscription}
                        threedotLoader={threedotLoader}
                        setThreedotLoader={setThreedotLoader}
                    />}
                </motion.div>
            )
            }
            {subscriptionSuccessModal && <SubscribeSuccess 
                subscriptionDetails={subscriptionDetails}
                subscriptionSuccessModal={subscriptionSuccessModal}
            />}
            
            
        </>
    
    )
}
const mapStateToProps = (state) => {
    const { Cart,ViewBulkOffer,Products,offerData }=state;
    return { Cart,ViewBulkOffer,Products,offerData }

};

const mapDispatchToProps = {
    GetBulkOfferDetails:DistributorActions.GetBulkOfferDetails,
    ProductList:DistributorActions.ProductListing,
    GetOfferData:DistributorActions.GetOfferData,
    cartList:DistributorActions.GetCartItems

}
export default connect(mapStateToProps, mapDispatchToProps)(BulkOfferDetails)